import { render, staticRenderFns } from "./LabsAddOrderModal.vue?vue&type=template&id=7eb80191&"
import script from "./LabsAddOrderModal.vue?vue&type=script&lang=js&"
export * from "./LabsAddOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports